// extracted by mini-css-extract-plugin
module.exports = {"content":"teamEfficiencyStats_content__suP_N","table":"teamEfficiencyStats_table__MHVDl"};